import { ResponsiveTableRow, Separator, H4 } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'
import TempleLabel from '../../common/TempleLabel'
import { getLastPathElement } from '../../../util/StringUtil'

export default function OwsPrintDateList({ printDateList, temples }) {
  const { t } = useTranslation()
  if (!printDateList || printDateList.length === 0) {
    return null
  }
  return (
    <>
      <H4 size="H5" supplementary>
        {t('ows.printDateList.printDates', 'Print Dates')}
      </H4>
      <DmcResponsiveTable
        atSizeColumns={{
          default: {
            labels: [
              t('date', 'Date'),
              t('temple.label', 'Temple'),
              t('temple.kiosk.info.kioskPrint', 'Kiosk Print'),
              t('temple.kiosk.info.locationType', 'Location Type'),
            ],
          },
        }}
        totalColumnCount={4}
      >
        {printDateList.map((proxyDate) => {
          const locationType = getLastPathElement(proxyDate.kioskLocationType)
          return (
            <ResponsiveTableRow
              key={proxyDate.date?.original}
              column1={proxyDate.date?.original}
              column2={temples && <TempleLabel temple={temples[proxyDate.templeRef?.templeCode]} />}
              column3={getLastPathElement(proxyDate.printSourceType) === 'KIOSK' ? 'Yes' : 'No'}
              column4={
                locationType === undefined ? '' : t(`temple.kiosk.printSourceType.${locationType}`, locationType)
              }
            />
          )
        })}
      </DmcResponsiveTable>
      <Separator />
    </>
  )
}
